/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

export default {
  methods: {
    updateBottomUp(isShow, bottomUpsName, indx, query) {
      if (isShow) {
        this._isTableOverFlow(query).then(overflow =>
          this.$set(this[bottomUpsName], indx, overflow)
        )
      } else {
        this.$set(this[bottomUpsName], indx, false)
      }
    },
    _isTableOverFlow(query) {
      const table = document.querySelector(query)

      return this.$nextTick().then(() => {
        return table.scrollHeight > table.clientHeight
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/flipDialogUp.js